import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AzureAuthenticationApiService {

  private readonly azureUrl: string = 'configuration/security/azure';
  private readonly testAzureUrl: string = `${this.azureUrl}/test`;

  constructor(private http: HttpClient) {}

  public getAuthenticationAzureConfiguration(): Observable<any> {
    return this.http.get(this.azureUrl);
  }

  public updateAuthenticationAzureConfiguration(configuration): Observable<any> {
    return this.http.put(this.azureUrl, configuration);
  }

  public testAuthenticationAzureConfiguration(configuration): Observable<any> {
    return this.http.put(this.testAzureUrl, configuration);
  }
}
